import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import CONSTANTS from '../../../_constants/constants';

import { SharedModule } from '../../../_shared/shared.module';

import { DateFormatPipe } from '../../../_shared/pipes/date-format.pipe';

import { User } from '../../shared/user.model';

@Component({
  selector: 'app-user-info-modal',
  templateUrl: './user-info-modal.component.html',
  standalone: true,
  imports: [SharedModule, DateFormatPipe],
})
export class UserInfoModalComponent {
  modalTitle = this.data.title;
  user: User = this.data.obj;

  dateDisplay = CONSTANTS.DATE_DISPLAY;

  constructor(
    private ref: MatDialogRef<UserInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}

  close() {
    this.ref.close();
  }
}
